import { apiListAll } from '@/core/api/resources'

export type StatusOption = { id: string; name: string }

export async function listStatus(): Promise<StatusOption[]> {
  const rows = await apiListAll('/status')
  return rows.map((s) => ({
    id: s.id,
    name: s.name,
  }))
}
